export default "__VITE_ASSET__e90a472b__"